const parseNumber = (value) => {
  if (value == null || value === "") {
    return null;
  }

  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

export const formatTenure = (value) => {
  const months = parseNumber(value);
  if (months == null || months < 0) {
    return "";
  }

  const totalMonths = Math.round(months * 100) / 100;
  const years = Math.floor(totalMonths / 12);
  const remainingMonths = Math.round((totalMonths - years * 12) * 100) / 100;
  const parts = [];

  if (years > 0) {
    parts.push(`${years} ${years === 1 ? "year" : "years"}`);
  }

  if (remainingMonths > 0 || years === 0) {
    parts.push(
      `${remainingMonths} ${remainingMonths === 1 ? "month" : "months"}`,
    );
  }

  return parts.join(", ");
};

const decimalFormatter = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

export const formatCourtedDecimal = (value) => {
  const number = parseNumber(value);
  return number == null ? "" : decimalFormatter.format(number);
};

const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const formatCourtedCurrency = (value) => {
  const number = parseNumber(value);
  return number == null ? "" : currencyFormatter.format(number);
};
